let autoOpened = false;
function initFilterModal() {
  const modal = document.getElementById("filterModal");
  const openBtn = document.getElementById("filterToggleBtn");
  const closeBtn = document.getElementById("filterModalClose");

  const isMobile = window.innerWidth < 990;

  // first remove any old listeners (to avoid duplicates)
  openBtn?.removeEventListener("click", openHandler);
  closeBtn?.removeEventListener("click", closeHandler);
  modal?.removeEventListener("click", outsideHandler);

  openBtn?.addEventListener("click", openHandler);
  closeBtn?.addEventListener("click", closeHandler);
  modal?.addEventListener("click", outsideHandler);

  function openHandler() {
    modal?.classList.add("open");
    autoOpened = true;
  }
  function closeHandler() {
    modal?.classList.remove("open");
    autoOpened = false;
  }
  function outsideHandler(e) {
    if (e.target === modal) modal.classList.remove("open");
  }
  
  if(isMobile && autoOpened) {
    modal?.classList.add("open");
  }
}

function initHideAdOnFiltering() {
  const collectionAds = document.querySelectorAll(".collection-ad");
  const collectionGrid = document.querySelector(".custom-collection-grid");
  if (!collectionAds.length) return;

  const url = new URL(window.location.href);
  // Look for any query-param key that begins with "filter."
  const hasFilterParam = Array.from(url.searchParams.keys()).some((key) =>
    key.startsWith("filter.")
  );

  if (hasFilterParam) {
    collectionAds.forEach((ad) => ad.classList.add("hidden"));
    collectionGrid.style.paddingBottom = "50px";
  } else {
    collectionAds.forEach((ad) => ad.classList.remove("hidden"));
    collectionGrid.style.paddingBottom = "";
  }
}

// on initial load
document.addEventListener("DOMContentLoaded", initFilterModal);
document.addEventListener("collection:reloaded", initFilterModal);
document.addEventListener("DOMContentLoaded", initHideAdOnFiltering);
document.addEventListener("collection:reloaded", initHideAdOnFiltering);

function repositionAds() {
  if (window.innerWidth >= 768) return;

  const grid = document.querySelector(".custom-collection-grid");
  if (!grid) return;

  const mobileCols = 2;

  // get only the product cards (exclude ads)
  const products = Array.from(grid.children).filter(
    (el) => !el.classList.contains("collection-ad")
  );

  grid.querySelectorAll(".collection-ad[data-ad-pos]").forEach((ad) => {
    const desktopPos = parseInt(ad.dataset.adPos, 10);

    // calculate which *mobile* row it should be in:
    // rows are 0‑based:
    //   rowIndex = ceil(desktopPos / mobileCols) - 1
    const rowIndex = Math.ceil(desktopPos / mobileCols) - 1;

    // insertion point = start of that row = rowIndex * mobileCols
    const insertionIndex = rowIndex * mobileCols;

    // clamp so we never run past the end
    const safeIndex = Math.min(insertionIndex, products.length);

    // find the node we want to insert *before*
    const refNode = products[safeIndex] || null;

    grid.insertBefore(ad, refNode);
  });
}

window.addEventListener("DOMContentLoaded", repositionAds);
window.addEventListener("resize", repositionAds);
